import { faCancel, faCrosshairs, faLock, faPencil } from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { useExpireSpdrs } from "./useExpireSpdrs";
import { confirm } from "../../../Layout/Dialog/ConfirmDialog";
import { useExcludeSpdrsFromScope } from "./useExcludeSpdrsFromScope";
import { useCreateProjectFromSpdrs } from "./useCreateProjectFromSpdrs";
import { useCreateTtProtectionFromSpdrs } from "./useCreateTtProtectionFromSpdrs";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";
import { isArrayUndefinedOrEmpty } from "../../../Utils/arrays";

type OverviewAction = {
  onClick: (selectedSpdrs: number[]) => void;
  text: string;
  icon: IconDefinition;
  disabled: (selectedItem: number[]) => boolean;
  roles: string[];
};

export const useSpdrOverviewActions = () => {
  const noItemsSelected = (selectedItem: number[]) => selectedItem.length === 0;

  // Expire
  const { mutate: expire } = useExpireSpdrs();
  const expireSpdrsButton: OverviewAction = {
    onClick: async (selectedSpdrs: number[]) => {
      if (isArrayUndefinedOrEmpty(selectedSpdrs)) return;
      const result = await confirm("Do you really want to expire the selected SPDRs?");
      if (result) {
        expire(selectedSpdrs);
      }
    },
    text: "EXPIRE",
    icon: faCancel,
    disabled: noItemsSelected,
    roles: AuthorizationPolicies.RequireAdminNetworkRoles,
  };

  // Exclude from Scope
  const { mutate: excludeFromScope } = useExcludeSpdrsFromScope();
  const excludeSpdrsFromScopeButton: OverviewAction = {
    onClick: async (selectedSpdrs: number[]) => {
      if (isArrayUndefinedOrEmpty(selectedSpdrs)) return;
      const result = await confirm("Do you really want to exclude the selected SPDRs from scope?");
      if (result) {
        excludeFromScope(selectedSpdrs);
      }
    },
    text: "EXCLUDE FROM SCOPE",
    icon: faCrosshairs,
    disabled: noItemsSelected,
    roles: AuthorizationPolicies.RequireAdminNetworkRoles,
  };

  // Create project from SPDRs
  const { mutate: createProjectFromSpdrs } = useCreateProjectFromSpdrs();
  const createProjectFromSpdrsButton: OverviewAction = {
    onClick: async (selectedSpdrs: number[]) => {
      if (isArrayUndefinedOrEmpty(selectedSpdrs)) return;
      createProjectFromSpdrs(selectedSpdrs);
    },
    text: "CREATE PROJECT",
    icon: faPencil,
    disabled: noItemsSelected,
    roles: AuthorizationPolicies.RequireAdminNetworkRoles,
  };

  // Create TT Protection from SPDRs

  const { mutate: createTtProtectionFromSpdrs } = useCreateTtProtectionFromSpdrs();
  const createTtProtectionFromSpdrsButton: OverviewAction = {
    onClick: async (selectedSpdrs: number[]) => {
      if (isArrayUndefinedOrEmpty(selectedSpdrs)) return;
      createTtProtectionFromSpdrs(selectedSpdrs);
    },
    text: "GENERATE TT PROTECTION",
    icon: faLock,
    disabled: noItemsSelected,
    roles: AuthorizationPolicies.RequireAdminRiskmanagerRoles,
  };

  return {
    expireSpdrsButton,
    excludeSpdrsFromScopeButton,
    createProjectFromSpdrsButton,
    createTtProtectionFromSpdrsButton,
  };
};
